export function mountShellProfileMenu({
  root,
  document: documentRef = globalThis.document,
} = {}) {
  const container = root?.querySelector?.('.shell-profile-menu');
  const toggle = container?.querySelector?.('[data-profile-menu-toggle]');
  const menu = container?.querySelector?.('[data-profile-menu]');
  if (!container || !toggle || !menu || !documentRef?.addEventListener) {
    throw new TypeError('Shell profile menu requires its container, toggle, menu, and document.');
  }

  let destroyed = false;

  const close = ({ restoreFocus = false } = {}) => {
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggle.focus();
  };
  const onToggle = () => {
    if (destroyed) return;
    const opening = menu.hidden;
    menu.hidden = !opening;
    toggle.setAttribute('aria-expanded', String(opening));
  };
  const onDocumentClick = (event) => {
    if (!container.contains(event.target)) close();
  };
  const onDocumentKeydown = (event) => {
    if (event.key !== 'Escape' || menu.hidden) return;
    event.preventDefault();
    close({ restoreFocus: true });
  };

  close();
  toggle.addEventListener('click', onToggle);
  documentRef.addEventListener('click', onDocumentClick);
  documentRef.addEventListener('keydown', onDocumentKeydown);

  return Object.freeze({
    close,
    destroy() {
      if (destroyed) return;
      destroyed = true;
      close();
      toggle.removeEventListener('click', onToggle);
      documentRef.removeEventListener('click', onDocumentClick);
      documentRef.removeEventListener('keydown', onDocumentKeydown);
    },
  });
}
